import { Box, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';
import { PhotoCard } from '../../components/photoCard';
import { GalleryPhoto } from '../types/galleryTypes';

interface GalleryPhotoListProps {
  photos: GalleryPhoto[];
  onPhotoClick: (photo: GalleryPhoto) => void;
}

export const GalleryPhotoList = observer(
  ({ photos, onPhotoClick }: GalleryPhotoListProps) => {
    const hasPhotos = photos?.length > 0;

    if (!hasPhotos) {
      return (
        <Box
          display="flex"
          justifyContent="start"
          alignItems="center"
          width="100%"
          pt={1}
        >
          <Typography variant="body2" style={{ opacity: 0.4 }}>
            No Photos Available.
          </Typography>
        </Box>
      );
    }

    return (
      <Box display="flex" gridGap="1rem" flexWrap="wrap">
        {photos.map(photo => {
          const url = photo.thumbnailImage || photo.image;
          const serverDate = photo.captureTimeIso
            ? new Date(photo.captureTimeIso)
            : null;

          return (
            <PhotoCard
              key={photo.uuid}
              url={url}
              preferredRotation={photo.preferredRotation}
              hasIssues={false}
              hasManualValidation={false}
              showStatusIcon={false}
              serverDate={serverDate}
              caption={photo.caption}
              onClick={() => onPhotoClick(photo)}
            />
          );
        })}
      </Box>
    );
  }
);
